

import React,{useEffect,useState,useRef,useCallback} from 'react'
import {Link} from 'react-router-dom'
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios'
import _ from 'lodash'
import { BASE_URL } from '../Config/Base';
import loader from '../Assets/Images/Loading_icon.gif'


const  FoundSectionWWHMain=()=>{

  const [addresswwh,setAddresswwh] = useState([]);
  const [file, setFile] = useState();
  const [fileB, setFileB] = useState();
  const [editItem, setEditItem] =useState([])
  const [display, setDisplay] =useState(true)
  const[edit,setEdit]= useState(true)
  const[del,setDel]= useState(true)
  const[pop,setpop] = useState(false);


  const pageSize = 3;

   const [paginatedPosts, setpaginatedPosts] = useState();
  // const [currentPage, setcurrentPage] = useState(1);

  function GetAddressWWH(){

    fetch(`${BASE_URL}/Foundation/GetWWHTable`, {
  
      method: 'GET',
  
      headers: {
  
        "Content-type": "application/json",
        "Accept": "application/json",
        "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  
      },
  
      //body:JSON.stringify(data)
  
    }).then(response => response.json())
  
      .then(data => {
        console.log("Data", data);
        setAddresswwh(data);
         setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        localStorage.setItem("paginationDataWWH", JSON.stringify(data));   
      }
      );
  
    }  
  

    // const pageCount = addresswwh? Math.ceil(addresswwh.length/pageSize) :0;
    // // if (pageCount === 1)
    // // return null;
    
    // const pages = _.range(1, pageCount+1)
    
    // const pagination =(pageNo)=>{
    // setcurrentPage(pageNo);
    // const startIndex = (pageNo - 1) * pageSize;
    // const paginatedPost = _(addresswwh).slice(startIndex).take(pageSize).value();
    // setpaginatedPosts(paginatedPost)
    // }
    



   
    useEffect(()=>{
      setpop(true);
      GetAddressWWH();
      getRoleData();
      getRole();
      document.getElementById('section-main').style.display = "none";

      setTimeout(()=>{
      setpop(false);
      GetAddressWWH();
      getUserRole();
      document.getElementById('section-main').style.display = "block";
    },1000)

    }, [])


    const handleFileChange = (e) => {
    
      setFile(e.target.files[0]);
      setFileB(e.target.value)
      document.getElementById("foundchangeinput").reset()
  
  };
  


    
  function AddAddress(){

    
    var count = document.getElementById('wwhcount').value;
    var content = document.getElementById('wwhcontent').value;
   
    if(!file)
    {
      document.getElementById('ImageErr').innerHTML='This Field is required'
    }
    else if(file)
    {
      document.getElementById('ImageErr').innerHTML=' '
    }

    if(!count)
    {
      document.getElementById('CountErr').innerHTML='This Field is required'
    }
    else if(count)
    {
      document.getElementById('CountErr').innerHTML=' '
    }


    if(!content)
    {
      document.getElementById('TextErr').innerHTML='This Field is required'
    }
    else if(content)
    {
      document.getElementById('TextErr').innerHTML=' '
    }

    if(file&&count&&content){
    const body={
  
      Image:file,
      Count:count,
      Content:content,
      }
  
      console.log('body',body);
       
      axios({
        
          method: "POST",
          url:`${BASE_URL}/Foundation/AddWWHTable`,
          data: body,
          headers: {
            "Content-Type" : "multipart/form-data"
             
          }
  
      })
    
      .then((response) =>{
        console.log(response.data);
  
        if(response.data.status === "Success"){
         
          alert("Add Successfully !");
          //  toast.success("Content Added Successfully !");
           GetAddressWWH();
           document.getElementById('addressform-clear').reset();
    
         }
      
         
      })
  
  .catch(error => {
    console.log(error);
    alert("Failed to Add !");
  //  toast.warning("Added failed !")
   
  })
}
    }


    function ConfirmDelete(Id){
     
      editItems(Id);
      document.getElementById("modalDeleteForm").style.display = "block";
      document.getElementById("DisplayEditPop").style.display = "none";
    }
    
    function Canceldel() {
      document.getElementById("modalDeleteForm").style.display = "none";      
        }
        
    
         function closedelForm()
         {
            document.getElementById("modalDeleteForm").style.display = "none";
          
          }
    

     //DeleteSection method

     function Deleteitems(Id){

  
      // var ans = window.confirm("Are you sure wat to delete this section?");
  
      // if(ans==true){

     const body =
      {
        id:Id,
        
      }
      console.log('body',body);

    
      axios({
             method:"POST",
             url :`${BASE_URL}/Foundation/DeleteWWHTable`,
             data:body, 
             headers: {
                "Content-type": "application/json",
                // "Authorization": "Bearer " +`${token}`, 
              }     
          }) 
  
         .then((response) =>{
         console.log(response.data);
    
         alert("Delete Successfully !");
              // toast.info("Contents Deleted")
            
              GetAddressWWH();
              closedelForm();
              // setcurrentPage(1);
    
      })
      .catch(error => {
        console.log(error);
     
      alert("Failed to Delete !")
      //toast.warning("failed to Delete")   
      })
        
     
    // }

    }

      /*Section Get Particular Data EditMethod*/

      function editItems(Id){

        setFile();
        setFileB();
        document.getElementById("DisplayEditPop").style.display = "block";
        
      const body =
       {
         
        id:Id
  
       }
       console.log('body',body);
  
     
       axios({
              method:"POST",
              url :`${BASE_URL}/Foundation/EditWWHTable`,
              data:body, 
              headers: {
                   "Content-type": "application/json",
                  //  "Authorization": "Bearer " + `${token}`,
    
               }     
           }) 
           
      
           .then((response) =>{
             console.log(response.data);
             setEditItem(response.data)
        
          })
          .catch(error => {
            console.log(error);
            
          })
  
       }

       ///Update  Section Method

     function updateItems(Id){

      var count1 = document.getElementById('wwhcountupdate').value;
      var content1 = document.getElementById('wwhcontentupdate').value;
      var Oldimg = document.getElementById('oldimg').value;
  
      if(!count1)
      {
        document.getElementById('UpdateCountErr').innerHTML='This Field is Required';
      }
      else if(count1){
        document.getElementById('UpdateCountErr').innerHTML=' ';
      }

      if(!content1)
      {
        document.getElementById('UpdateTextErr').innerHTML='This Field is Required';
      }
      else if(content1){
        document.getElementById('UpdateTextErr').innerHTML=' ';
      }

      if(content1&&count1&&Oldimg){

      const body={

        Id:Id,
        Image:file,
        Count:count1,
        Content:content1,
        OldImage:Oldimg

        }

    console.log('body',body);

  
    axios({
           method:"POST",
           url :`${BASE_URL}/Foundation/UpdateWWHTable`,
           data:body, 
           headers: {
                "Content-Type": "multipart/form-data",
                // "Authorization": "Bearer " + `${token}`,
            }     
        }) 

       .then((response) =>{
       console.log(response.data);
      
  
       if(response.data.status === "Success"){
        alert("Update Successfully !");
            // toast.success("Contents Updated Successfully")
            GetAddressWWH();
            setFile();
            setFileB();

            setTimeout(()=>{
            
              closeForm();
         
          },1000)

          }
  
    })
    .catch(error => {
      console.log(error);
  
    alert("Failed to Update !")
    // toast.warning("failed to Update")   
    })
      
  }
    }


     //closeSectionForm

     function closeForm(){

      document.getElementById("DisplayEditPop").style.display = "none";
      document.getElementById("formA").reset();
      document.getElementById("foundchangeinput").reset()
    }

    
     
    function getRoleData(){
     
      
      let UserRole =  localStorage.getItem("Role");
     
      const body ={
       
       roles:UserRole
     
      }
      console.log(body);
     
      const token = JSON.parse(localStorage.getItem('usertoken'));
     
       axios({          
          method: "POST", 
          url:`${BASE_URL}/Foundation/GetUserLoginRoles`,      
          data:body,
          headers:{             
            'Content-Type': 'application/json' , 
            "Authorization": "Bearer " + `${token}`     
          }
        
        })
        .then((response) =>{
         console.log(response.data);
         localStorage.setItem("loginUserRoleaction", JSON.stringify(response.data));
         
          }) 
        
         }
 
 
         function getRole(){
     
           const token = JSON.parse(localStorage.getItem('usertoken'));
     
           fetch(`${BASE_URL}/Foundation/FoundationGetRoles`, {
             method:'GET',
       
           headers : {
       
             "Content-type": "application/json",
       
             "Accept": "application/json",
       
             "Authorization": "Bearer " +`${token}`,
       
             "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
           },
       
       
       })
       
                 .then(response => response.json())
       
       
                   .then(data => {
                    console.log("Role",data)
                   //  setRoletable(data)
                     localStorage.setItem("Data", JSON.stringify(data));
                   });
           }



           function getUserRole(){
  
            /**----getroleAction---- */
        let Tcrole =  localStorage.getItem("loginUserRoleaction");
        let roledata =  JSON.parse(Tcrole);
        let role = roledata.map((e)=>e.roleAction);
        console.log(role);
        
        let roles = role.toString();
        let add = roles.includes('Add')
        console.log(add)
        
        let view = roles.includes('View')
        console.log(view)
        
        let edit = roles.includes('Edit')
        console.log(edit)
        
        let del= roles.includes('Delete')
        console.log(del)


        let empty = roles.includes('')
        console.log(empty)
  

        let roleid = localStorage.getItem('RoleId')
        let id = roleid.includes('01')
        console.log(id)


        if(id==true&&empty==true&&add==false&&view==false&&edit==false&&del==false)
        {
          setDisplay(true);
          setEdit(true);
          setDel(true);
        
        }
        if(id==false&&empty==true&&add==false&&view==false&&edit==false&&del==false)
        {
          setDisplay(false);
          setEdit(false);
          setDel(false);
          document.getElementById('Foundsectiontable').style.display ="none";
          document.getElementById('Add-section-btn').style.display ="none";
          document.getElementById('wwhcount').style.display ="none";
          document.getElementById('wwhcontent').style.display ="none";
          document.getElementById('filechoose-input').style.display ="none";
          document.getElementById('Foundaction-err').innerHTML = 'Not Assign'
          document.getElementById('Foundaction-err').style.color = "red"
          document.getElementById('Foundaction-err').style.fontWeight = "bold"
          document.getElementById('Foundaction-err').style.alignItems = "center"
          document.getElementById('Foundaction-err').style. justifyContent = "center"
          document.getElementById('Foundaction-err').style. display= "flex"
   
         
        }
        
        
        
            
            if( view==true){
              setDisplay(false);
              document.getElementById('Add-section-btn').style.display ="none";
              document.getElementById('wwhcount').style.display ="none";
          document.getElementById('wwhcontent').style.display ="none";
          document.getElementById('filechoose-input').style.display ="none";
               
            }
            if(add==true){
              setDisplay(false);
              document.getElementById('Add-section-btn').style.display ="block";
              document.getElementById('wwhcount').style.display ="block";
          document.getElementById('wwhcontent').style.display ="block";
          document.getElementById('filechoose-input').style.display ="block";
               
            }
            if(edit==true){
              setDisplay(true);
              setEdit(true)
              setDel(false)
              document.getElementById('Add-section-btn').style.display ="none";
              document.getElementById('wwhcount').style.display ="none";
              document.getElementById('wwhcontent').style.display ="none";
              document.getElementById('filechoose-input').style.display ="none";
            }

            if(del==true){
              setDisplay(true);
              setEdit(false)
              setDel(true)
              document.getElementById('Add-section-btn').style.display ="none";
              document.getElementById('wwhcount').style.display ="none";
              document.getElementById('wwhcontent').style.display ="none";
              document.getElementById('filechoose-input').style.display ="none";
            }

            if(add==true&& view==true&& edit==true&& del==true)
            {
              setDisplay(true);
              setEdit(true);
              setDel(true);
              document.getElementById('Add-section-btn').style.display ="block";
              document.getElementById('wwhcount').style.display ="block";
              document.getElementById('wwhcontent').style.display ="block";
              document.getElementById('filechoose-input').style.display ="block"; 
            }

            if(edit==true&&del==true)
            {
              setDisplay(true);
              setEdit(true);
              setDel(true);
              document.getElementById('Add-section-btn').style.display ="none";
            document.getElementById('wwhcount').style.display ="none";
            document.getElementById('wwhcontent').style.display ="none";
            document.getElementById('filechoose-input').style.display ="none";
            }
            
            if(add==true&& edit==true)
          {
              setDisplay(true);
              setEdit(true);
              setDel(false);
              document.getElementById('Add-section-btn').style.display ="block";
              document.getElementById('wwhcount').style.display ="block";
              document.getElementById('wwhcontent').style.display ="block";
              document.getElementById('filechoose-input').style.display ="block";
            }

            if(add==true&& del==true)
            {
                setDisplay(true);
                setEdit(false);
                setDel(true);
                document.getElementById('Add-section-btn').style.display ="block";
                document.getElementById('wwhcount').style.display ="block";
                document.getElementById('wwhcontent').style.display ="block";
                document.getElementById('filechoose-input').style.display ="block";
              }

            if(add==true&& edit==true&& del==true)
          {
              setDisplay(true);
              setEdit(true);
              setDel(true);
              document.getElementById('Add-section-btn').style.display ="block";
              document.getElementById('wwhcount').style.display ="block";
              document.getElementById('wwhcontent').style.display ="block";
              document.getElementById('filechoose-input').style.display ="block";
            }
            
            
      

          } 

          
          const LEFT_PAGE = "LEFT";
          const RIGHT_PAGE = "RIGHT";
          const range = (from, to, step = 1) => {
            let i = from;
            const range = [];
          
            while (i <= to) {
              range.push(i);
              i += step;
            }
          
            return range;
          };
          const [currentPage, setCurrentPage] = useState(1);

          let data = localStorage.getItem("paginationDataWWH")
          let transdata =  JSON.parse(data);
          let NUM_OF_RECORDS = transdata.length;
          let LIMIT = 5;
          
          const onPageChanged = useCallback(
          
            (event, page) => {
              event.preventDefault();
              setCurrentPage(page);
            },
            [setCurrentPage]
            
          );
          
          
          const currentData = transdata.slice(
            (currentPage - 1) * LIMIT,
            (currentPage - 1) * LIMIT + LIMIT
          );
          
          const Paginations = (props) => {
            const {
              totalRecords,
              pageLimit,
              pageNeighbours,
              onPageChanged,
              currentPage
            } = props;
            const [totalPages, setTotalPages] = useState(0);
            useEffect(() => {
              setTotalPages(Math.ceil(totalRecords / pageLimit));
            }, [setTotalPages]);
          
            const fetchPageNumbers = () => {
              const totalNumbers = pageNeighbours * 1 + 0;
              console.log(totalNumbers)
              console.log(pageNeighbours)
              const totalBlocks = totalNumbers + 2;
              console.log(totalBlocks)
          
              if (totalPages > totalBlocks) {
                const startPage = Math.max(2, currentPage - pageNeighbours);
                const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);
          
                let pages = range(startPage, endPage);
          
                const hasLeftSpill = startPage > 2;
                const hasRightSpill = totalPages - endPage > 1;
                const spillOffset = totalNumbers - (pages.length + 1);
          
                switch (true) {
                  case hasLeftSpill && !hasRightSpill: {
                    const extraPages = range(startPage - spillOffset, startPage - 1);
                    pages = [LEFT_PAGE, ...extraPages, ...pages];
                    break;
                  }
                  case hasLeftSpill && hasRightSpill:
                  default: {
                    pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
                    break;
                  }
                }
                return [1, ...pages, totalPages];
              }
              return range(1, totalPages);
            };
          
          
            const pages = fetchPageNumbers() || [];
            return (
              <nav aria-label="Countries Pagination" id='foundnavpag'>
                <ul className="pagination">
                  {pages.map((page, index) => {
                    if (page === LEFT_PAGE)
                      return (
                        <li key={index} className="page-item">
                          <a
                            href="/"
                            className="page-link"
                            aria-label="Previous"
                            onClick={(e) => onPageChanged(e, pageNeighbours * 2 - 1)}
                          >
                            <span aria-hidden="true">&laquo;</span>
                          </a>
                        </li>
                      );
          
                    if (page === RIGHT_PAGE)
                      return (
                        <li key={index} className="page-item">
                          <a
                            className="page-link"
                            href="/"
                            aria-label="Next"
                            onClick={(e) => onPageChanged(e, pageNeighbours * 2 + 1)}
                          >
                            <span aria-hidden="true">&raquo;</span>
                          </a>
                        </li>
                      );
          
                    return (
                      <li
                        key={index}
                        className={`page-item${currentPage === page ? " active" : ""}`}
                      >
                        <a
                          className="page-link"
                          href="/"
                          onClick={(e) => onPageChanged(e, page)}
                        >
                          {page}
                        </a>
                      </li>
                    );
                  })}
                </ul>
              </nav>
            );
          };

  return(
    
    <div className='foundation-addmain'>

    <div className="foundation-addgrid-layout"> 
    <div className="foundation-addmain-top">
    <div className='foundation-addmain-back'>
    <Link to='/FoundSectionHome'><i class="fa fa-chevron-left" aria-hidden="true"></i></Link>
    </div> 
    <span>Where we have been</span>
    </div>
    </div>

    <span id="Foundaction-err"></span>

    
    {pop?<div className='text-center'><img src={loader} alt="loader" id='loading-Indicator'/></div>
        :null}
    

<div id='section-main'>

<div className='foundation-WWHtable-section' >
{/* <div className="modal-dialog" role="document">
<div className="modal-content"> */}

<form  id='addressform-clear'  onSubmit={AddAddress}>
<div className="modal-body mx-4">

<div className='text-center'>
{/* <h4>Images,Count and Content</h4> */}
</div>

<br></br>

<div className='col-sm-12'>
<div className='row'> 

<div className='col-sm-5'> 
<div className="md-form mb-0" >
<input type="file" onChange={handleFileChange} id='filechoose-input'/>
<span id='ImageErr' className='errorsection'></span>
</div>
</div>

<div className='col-sm-5'> 
<div className="md-form mb-0">
<input type="text" id='wwhcount' placeholder='Count'/>
<span id='CountErr' className='errorsection'></span>
</div>
</div>

<br></br><br></br><br></br>

<div className='col-sm-5'> 
<div className="md-form mb-0">
<textarea type="text"  cols={2} rows={1} id='wwhcontent' placeholder='Content'/>
<span id='TextErr' className='errorsection'></span>
</div>
</div>

<div className='col-sm-2'> 
<div className="md-form mt-2">
<button className='foundation-Assign-button' id='Add-section-btn' type='submit'>ADD</button>
</div>
</div>


</div>
</div>
</div> 

{/* <div className="d-flex justify-content-center">

</div> */}


</form>


</div>
{/* </div> */}

{/* EditPopup */}

<div className='foundation-pop-fade' id="DisplayEditPop">
{editItem.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content"  style={{marginTop:"135px"}}> 
    <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT SECTION</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div> 
  <form id='formA' onSubmit={()=>updateItems(e.id)}>
  <div className="modal-body mx-3">
  <div className="md-form mb-4">
  <label>Images</label>
  {/* <input type="text"  id='oldimg' value={e.images}  ></input> */}
 
  {!file?
         <div><input type="file" style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChange}/>
         <div style={{border:"1px solid lightgrey",height:"43px",padding:"1px 12px 1px 12px",borderRadius:"2px",marginTop:"-50px"}}>
         <input defaultValue={e.images}  id="oldimg" style={{border:"none",marginLeft:"84px",fontSize:"12px",background:"transparent",position:"relative"}}/>
          <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
          {/* &nbsp;<span >{e.fileName}</span> */}
          </div>
         </div>:
  
          <div><form id="foundchangeinput"><input type="file" style={{opacity:"0",position:"relative",top:"50px",left:"0px",zIndex:"1",top:"0"}} onChange={handleFileChange}/>
          <div style={{border:"1px solid lightgrey" ,height:"46px",padding:"1px 12px 6px ",borderRadius:"2px",marginTop:"-50px",color:"green"}}>
          <input defaultValue={fileB}  style={{border:"none",marginLeft:"84px",background:"transparent",position:"relative"}}/>
           <span style={{border:"1px solid black",backgroundColor:"#efefef",padding:"2px 2px 2px",borderRadius:"2px",position:"absolute",marginTop:"-38px"}}>Choose File</span>
        
           </div></form> <input defaultValue={e.images} id="oldimg" style={{display:"none"}} /></div>}
 
 
  </div>

 

  <div className="md-form mb-4">
  <label>Count</label>
  <input type="text" id='wwhcountupdate' defaultValue={e.count} placeholder='Count'/>
  <span id='UpdateCountErr' className='errorsection'></span>
  </div>

  <div className="md-form">
  <label>Content</label>
  <input type="text" id='wwhcontentupdate' defaultValue={e.content} placeholder='Content'/>
  <span id='UpdateTextErr' className='errorsection'></span>
  </div> 
  
  
  </div>
  
  <div className="modal-footer d-flex justify-content-center">
  <button type="submit"  id='foundation-section-buttonA'>Update</button>
  </div>
  </form>
  </div>
  </div>})}
 </div>


 {/* DeletePopup */}

 <div className="foundation-pop-fade" id="modalDeleteForm" tabindex="-1" role="dialog">
 {editItem.map((e)=>{ 
   return<div className="modal-dialog" role="document">
      <div className="modal-content"  style={{marginTop:"280px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closedelForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-0">
            <div className='text-center'>
          <h5>Are you sure want to delete this Content?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="foundation-deleteuser-button"  onClick={()=>Deleteitems(e.id)} type='submit'>Delete</button>
        <button className="foundation-deleteuser-button"  onClick={Canceldel} type='submit'>Cancel</button>
       </div>
       </form>
      
     </div>
    </div>
    })} 
</div>

<div className='foundationContent-table'>
<div className="table_foundationContent-responsive " id="Foundsectiontable">

{/* <div className='text-center'>
<h5>Counts of Details </h5>
</div> */}
{/* {
  !paginatedPosts ? (" "):( */}
    <table>
      <thead>
        <tr>
          <th>Images</th>
          <th>Count</th>
          <th>Content</th>
          {display?<th>Action</th>:null}
        </tr>
      </thead>
    <tbody>
      {currentData.map((e)=>{
      return <tr>
        <td><img src={e.images} id="Found-table-img"/></td>
        <td>{e.count}</td>
        <td>{e.content}</td>
        {display?<td className='text-center'>
        {edit?<span><i class="fa fa-pencil" aria-hidden="true" onClick={()=>editItems(e.id)} id="FoundEditicon"></i></span>:null} &nbsp;&nbsp;
                 {del? <span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id)}  id="FoundDelicon" ></i></span>:null}
            </td>:null}

      </tr>
      })}
    </tbody>
 
   
    </table>
  {/* )} */}

 
  <br></br>



  {transdata.length<=5? null:<div>{

!paginatedPosts ? (""):(
<Paginations
            totalRecords={NUM_OF_RECORDS}
            pageLimit={LIMIT}
            pageNeighbours={1}
            onPageChanged={onPageChanged}
            currentPage={currentPage}
          />
          )}
          </div>
}

  {/* <nav>
    <ul className='pagination'>
      {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='page-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      }
       

    </ul>
  </nav> 
   */}


</div>
</div>

 

</div>
</div>
   
  )
}

export default FoundSectionWWHMain